<template>
  <button class="btn btn-success" @click.prevent="handleShowModal">
    Notes
  </button>
</template>

<script>
import DeviceLoanNotesModal from '@/components/DeviceLoanNotes/DeviceLoanNotesModal'

export default {
  name: 'DeviceLoanNotes',
  components: {
    
  },
  props: {
    loan: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleShowModal() {
      return this.$modal.show(DeviceLoanNotesModal, {
        loan: this.loan
      }, 
      { height: 'auto', scrollable: true })
    }
  }
}
</script>
